import { render, staticRenderFns } from "./OrdinalSequence.vue?vue&type=template&id=5f942dba&"
import script from "./OrdinalSequence.vue?vue&type=script&lang=js&"
export * from "./OrdinalSequence.vue?vue&type=script&lang=js&"
import style0 from "./OrdinalSequence.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports